<script>
  import Details from '../Modal/Details.svelte';
  import { COUNTRIES, CURRENT_COUNTRY } from '../stores.js';
  import { LABELS, NOT_AVAILABLE, VALUES, colors } from '../config.js';
  import { gs } from '../scripts/utils.js';
  import tooltip from '../scripts/tooltip.js';
  import { getContext } from 'svelte';
  import map from 'lodash/map'
  import get from 'lodash/get'

  const { open } = getContext('simple-modal');

  // Country data
  let data;
  COUNTRIES.subscribe(value => { data = value });

  $: elements = map(data, (country, i) => {
    const status = gs(country, 'status')
    return {
      id: get(country, 'id'),
      label: gs(country, 'label'),
      status,
      link: get(country, 'link'),
      contacts: get(country, 'contacts'),
      location: get(country, 'location'),
      color: get(VALUES, status, colors.other)
    }
  })

  const showSurprise = (id) => {
    CURRENT_COUNTRY.update(() => id);
    open(Details);
  };
</script>

<div class="page-table">
  <table class="view-table">
    <thead>
      <tr>
        <th>{ LABELS.TABLE_LAND }</th>
        <th>{ LABELS.TABLE_STATUS }</th>
        <th class="hideBelowNarrow">{ LABELS.TABLE_CONTACT }</th>
        <th class="hideBelowNarrow">{ LABELS.TABLE_LOCATION }</th>
      </tr>
    </thead>
    <tbody class="hoverable">
      {#each elements as { id, label, status, add, link, contacts, location, date, color, content }}
        <tr>
          <td
            class="label clickable"
            on:click={() => showSurprise(id)}
            use:tooltip={{content: `<span>${'Klicken für weitere Informationen'}</span>`, followCursor: false }}>{ label }</td>
          <td class="status"><i class="dot" style="background-color: {color}" />{ status }</td>
          {#if contacts.length}
            <td class="hideBelowNarrow">
              {#each contacts as [ contact, mail ], i}
              <a href={`mailto:${mail}`} use:tooltip={{content: `<span>${'Klicken um per Mail zu kontaktieren'}</span>`, followCursor: false }} class="btn">{ contact ? contact : LABELS.TABLE_CONTACT_LABEL }</a>
              {/each}
            </td>
          {:else}
            <td class="hideBelowNarrow">{ NOT_AVAILABLE }</td>
          {/if}
          {#if link}
            <td class="hideBelowNarrow"><a target="_blank" href={link} use:tooltip={{content: `<span>${'Klicken um Webseite des Länderbüros zu öffnen'}</span>`, followCursor: false }}>{ location }</a></td>
          {:else}
            <td class="hideBelowNarrow">{ NOT_AVAILABLE }</td>
          {/if}
        </tr>
      {/each}
    </tbody>
  </table>
</div>
